// A stub for firebase analytics
// in the web
// This is so that the trackActions utility
// can keep working the same between web and mobile
// For mobile clients see .android and .ios files
export default {
    logEvent() {}
}